import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";

import { logoutUser } from "../../slices/thunks";

//redux
import { useSelector, useDispatch } from "react-redux";

import withRouter from "../../Components/Common/withRouter";
import { createSelector } from "reselect";
import type { RootState } from "../../slices";

const Logout = (props: any) => {
  const dispatch: any = useDispatch();


  const logoutData = createSelector(
    (state: RootState) => state.Login,
    (isUserLogout) => isUserLogout.isUserLogout
  );

  // Inside your component
  const isUserLogout = useSelector(logoutData);

  useEffect(() => {
    dispatch(logoutUser());
  }, [dispatch]);

  if (isUserLogout) {
    // Dang xuat xong luon ve /login khong kem "from" — dang nhap lai se mac dinh ve /dashboard
    // (khac voi luong AuthProtected redirect khi truy cap thang 1 trang chua dang nhap, van con
    // giu "from" o do de quay lai dung trang).
    return <Navigate to="/login" />;
  }

  return <React.Fragment></React.Fragment>;
};

Logout.propTypes = {
  history: PropTypes.object,
};


export default withRouter(Logout);
